module.exports = __webpack_public_path__ + "static/media/arrow_circle_right.07bf363a.svg";